export const adaptAlimentacionParenteral = (queryData) => {
    const { alimentacionParenteralRIByDatosGeneralesId: apData } = queryData

    return {
        programaAP1: {
            idAlimentacionParenteralRI: apData?.idAlimentacionParenteralRI,
            idComboRIValorKarnofsky: apData?.idComboRIValorKarnofsky,
            calorias: apData?.calorias,
            hidratosCarbono: apData?.hidratosCarbono,
            proteinas: apData?.proteinas,
            lipidos: apData?.lipidos,
            proteinasTotales: apData?.proteinasTotales,
            lipidosTotales: apData?.lipidosTotales,
            caloriasTotales: apData?.caloriasTotales,
            formulaSchofieldPed: apData?.formulaSchofieldPed,
            laboratorio: apData?.laboratorio,
            laboratorioAdjunto: {
                contentType: apData?.laboratorioAdjunto?.contentType,
                archivo: apData?.laboratorioAdjunto?.archivo,
                extension: apData?.laboratorioAdjunto?.extension,
                titulo: apData?.laboratorioAdjunto?.titulo,
            }
        },
        programaAP2: {
            idAlimentacionParenteralRI: apData?.idAlimentacionParenteralRI,
            idComboRIValorTipoCateter: apData?.idComboRIValorTipoCateter,
            justificarTipoCateter: apData?.justificarTipoCateter,
            fechaColocacionCateter: apData?.fechaColocacionCateter,
            idComboRIValorUbicacionCateter: apData?.idComboRIValorUbicacionCateter,
            idComboRIValorNroLumenes: apData?.idComboRIValorNroLumenes,
            insercionCateterNormal: apData?.insercionCateterNormal,
            magistral: apData?.magistral,
            bAPestandar: apData?.bAPestandar,
            idComboRIValorMotivoIndicacionEstandar: apData?.idComboRIValorMotivoIndicacionEstandar,
            bAPxAdelantado: apData?.bAPxAdelantado,
            idComboRIValorModoInfusion: apData?.idComboRIValorModoInfusion,
            idComboRIValorSelladoCateter: apData?.idComboRIValorSelladoCateter,
            volumenMagistral: apData?.volumenMagistral,
            diasConexionSemanaMagistral: apData?.diaConexionMagistral,
            diasConexionSemana: apData?.diaConexionEstandar,
            idInsumo: apData?.indicacionRI?.idInsumo,
            nombreInsumo: apData?.indicacionRI?.idInsumoNavigation?.descripcion,
            cantidadDiaria: apData?.indicacionRI?.cantidadDiaria,
        },
    }
}